<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('tableDelete') }}</h5>
                        <button type="button" class="btn-close" data-dismiss="modal" @click="$emit('close')"aria-label="Close" />
                    </div>
                    <div class="modal-body">
            
                    <p>{{ $t('wannaDeleteThisTable') }}</p>
                        <p style="margin-bottom:0; color: red">{{ $t('allDataWillBeLost') }}</p>
                    </div>
                    <div class="modal-footer">
                        <button v-bind:class="[buttonLoading, syncLoading]" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            {{ $t('loading') }}
                        </button>
                        <button type="button" class="btn btn-secondary" @click="$emit('close')" data-dismiss="modal" >
                            {{ $t('close') }}
                        </button>
                        <button type="button" class="btn btn-primary" @click="deleteDataTable" >
                            {{ $t('delete') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import DataSpaceApi from '../../api/server/dataspace';


export default {
    name: "dataTableModal",
    methods: {
        async deleteDataTable() {
            this.syncLoading = "";
            await DataSpaceApi.tableDelete(this.$parent.$route.params.id, this.$parent.tableToDeleteName);
            this.$emit("reload");
            this.$emit('close');
        }
    },
    data() {
        return {
            buttonLoading: 'btn btn-primary',
            syncLoading: "hidden",
            files: [],
        };
    }
};
</script>
